import styled from 'styled-components';

export const PaneButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  gap: 12px;
  border-top: 1px solid #E2E7ED;
`;

export const PaneContent = styled.div`
  padding: 0 20px 20px;
  color: #021733;
  font-size: 14px;
`;
